<template>
  <div :id="toastContainerId" ref="pictureContainerRef">
    <ToastRenderer
      v-if="isPictureToastVisible"
      message="Photo unavailable for this color"
      class="picture-wrapper"
      :toast-container-id="toastContainerId"
      placement="bottom"
      :duration="0"
      :on-close="handleManualClose"
    />
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted, onUnmounted } from 'vue';
import ToastRenderer from '@atomic-ui/toast/ToastRenderer';

const props = defineProps({
  toastContainerId: { type: String, required: true },
  isZoomedIn: { type: Boolean, default: false },
  selectedColor: { type: Object, required: true },
});

const pictureContainerRef = ref(null);
const isToastManuallyClosed = ref(false);
const isIntersecting = ref(false);
let observer;

const isPictureToastVisible = computed(() => {
  return isIntersecting.value && !props.isZoomedIn && !isToastManuallyClosed.value;
});

watch(
  () => props.selectedColor,
  () => {
    isToastManuallyClosed.value = false;
  },
);

const handleManualClose = () => {
  isToastManuallyClosed.value = true;
};

onMounted(() => {
  observer = new IntersectionObserver(([entry]) => {
    isIntersecting.value = entry.isIntersecting;
  });

  if (pictureContainerRef.value) {
    observer.observe(pictureContainerRef.value);
  }
});

onUnmounted(() => {
  if (observer) {
    observer.disconnect();
  }
});
</script>
<style lang="scss" scoped>
.picture-wrapper {
  cursor: pointer;
}
</style>

<style lang="scss" brand="mcom" scoped>
.toast-content {
  width: rem-calc(192);
}
</style>

<style lang="scss" brand="bcom" scoped>
.toast-content {
  width: rem-calc(208);
  white-space: nowrap;
}
</style>
